export default __webpack_public_path__ + "img/new_members-4ab3e62620017cd6aefa8158cac540f4.png";